import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BaseService } from '../../../../../services/base.service';
import { Subject, takeUntil } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InviteForm } from './invite-manager.interface';
import { IError, IGroups } from '../../../../../interfaces';
import { CrmService } from '../../../../../services/crm.service';
import { NotificationService } from '../../../../../services/notifications.service';
import { ERROR_MESSAGES } from '../../../../../enum/constants';

@Component({
  selector: 'app-invite-manager',
  templateUrl: './invite-manager.component.html',
  styleUrl: './invite-manager.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InviteManagerComponent implements OnInit, OnDestroy {
  @Input() payload: any;
  @Output() close = new EventEmitter<any>();

  // Destroy
  private readonly destroy$ = new Subject<null>();

  // Form
  public inviteForm!: FormGroup<InviteForm>;

  // Var`s
  public groups: IGroups[] = [];
  public isLoader: boolean = false;

  constructor(
    public crmService: CrmService,
    public baseService: BaseService,
    public notificationService: NotificationService,
  ) {}

  public ngOnInit(): void {
    this.isLoader = true;
    this.initForm();
    this.getAllGroups();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public onCloseSidebar(): void {
    this.close.emit('close');
  }

  private initForm(): void {
    this.inviteForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      role: new FormControl(null, Validators.required),
    });
  }

  public onSendInvite(): void {
    this.inviteForm.markAllAsTouched();

    if (this.inviteForm.valid) {
      this.isLoader = true;
      const { email, role } = this.inviteForm.getRawValue();

      this.crmService
        .sendInvite({
          email: email,
          role: role.name,
          group_id: role.id,
        })
        .subscribe({
          next: () => {
            this.isLoader = false;
            this.close.emit('success');
          },
          error: (e: any) => {
            this.isLoader = false;
            (e.error?.errors || []).forEach((err: IError) => {
              this.notificationService.showError('', ERROR_MESSAGES[err.code]);
            });
          },
        });
    }
  }

  private getAllGroups(): void {
    this.crmService
      .getAllGroups({ page: 1, take: 25, access_change_own_role: true })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (v) => {
          this.groups = v.items;
          this.isLoader = false;
        },
        error: (e: any) => {
          this.isLoader = false;
          (e.error?.errors || []).forEach((err: IError) => {
            this.notificationService.showError('', ERROR_MESSAGES[err.code]);
          });
        },
      });
  }
}
